import classes from './full-main-height.module.css';

interface FullMainHeightContentProps {
  children: React.ReactNode;
}

export const FullMainHeightContent = ({
  children,
}: FullMainHeightContentProps) => {
  return (
    <div className={classes.contentWrapper}>
      <div className={classes.content}>{children}</div>
    </div>
  );
};
